import type { InjectionKey, Ref } from 'vue'

export type OfferRewardTypeBlockContext = {
  formTouched: Ref<boolean>
  rewardTypeIdsBySlug: Ref<Record<string, number> | null>
  accessConditions?: {
    resetOnRewardTypeChange?: () => void
  }
}

export const offerRewardTypeBlockKey: InjectionKey<OfferRewardTypeBlockContext> = Symbol('offerRewardTypeBlock')
